import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import { useAuth } from "./AuthHook";

const SubCategoriesContext = createContext();

export default function SubCategoriesProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();
  const [currentSubCategories, setSubCategories] = useState([]);

  const updateSubCategories = async (forCategory) => {
    logger.debug(
      "SubCategoriesProvider.updateSubCategories",
      `GET field/workOrder/subcategory/${forCategory}`
    );
    const data = await auth.get(
      encodeURI(`field/workOrder/subcategory/${forCategory}`)
    );
    if (data) {
      // data should be an array of strings
      logger.debug(
        "SubCategoriesProvider.updateSubCategories",
        `Retrieved data`
      );
      data.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
      if (data) {
        setSubCategories(data);
      } else {
        setSubCategories([]);
      }

      return data;
    }
    logger.debug(
      "SubCategoriesProvider.updateSubCategories",
      `Failed to retrieve data`
    );
    return [];
  };

  const getSubCategories = () => currentSubCategories;

  return (
    <SubCategoriesContext.Provider
      value={{
        getSubCategories,
        updateSubCategories,
      }}
    >
      {children}
    </SubCategoriesContext.Provider>
  );
}

SubCategoriesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useSubCategories = () => useContext(SubCategoriesContext);
